(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('afApp')
        .constant('CONST_AF_REQUEST', {
        	'REASON_TORN' : "HSYCBH bị rách",
        	'REASON_DIRTY' : "HSYCBH bị dơ",
        	'REASON_DUFF' : "HSYCBH bị hư",
        	'REASON_WRONG_INSURANCE' : "GA cấp phát sai HSYCBH",
        	'REASON_GP' : "Nhận cho GP/Other event",
        	'URL_MENU':"menu/#/menu",
        	'URL_AF_REQUEST' : "af/#/afForm"
        });
})();
